import {Component, Inject, LOCALE_ID, OnInit} from '@angular/core';
import {TemplateComponent} from "../../template/template.component";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";

@Component({
  selector: 'app-performance-section',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './performance-section.component.html',
  styleUrl: './performance-section.component.css'
})
export class PerformanceSectionComponent  implements  OnInit{

  performanc:any;

  constructor(public route: Router,
              public global: GlobalService,
              @Inject(LOCALE_ID) public locale: string) {

  }

  ngOnInit() {
    if (this.global.getMainData()['main-page'] != null) {
      this.performanc = JSON.parse(this.global.getMainData()['main-page']['data'])['performance-bar'];
      setTimeout(() => {
        this.performanc = JSON.parse(this.global.getMainData()['main-page']['data'])['performance-bar'];
      }, 1000)
    }
  }

  getDirection(): string {
    if (this.locale == "fa") {
      return "rtl";
    } else {
      return "ltr";
    }
  }

}
